module.exports = __webpack_public_path__ + "img/notify_info.533f6b85.svg";